document.addEventListener("DOMContentLoaded", function () {
    let buttons = document.querySelectorAll(".mobileremovehide .slider-counter__link");
    buttons.forEach((btn, index) => {
        if (btn.classList.contains("slider-counter__link--active")) {
            if (buttons[index - 1]) {
                buttons[index - 1].classList.add("prev-slide");
            }
            if (buttons[index + 1]) {
                buttons[index + 1].classList.add("next-slide");
            }
        }
    });
  });